import { S3Level } from 'API';
import { ImgHTMLAttributes, useEffect, useState } from 'react';
import StorageService from 'services/storage';

interface Props extends ImgHTMLAttributes<HTMLImageElement> {
  callback?: Function;
  imgkey: string;
  level?: S3Level;
  identityId?: string;
}

const S3Image: React.FC<Props> = (props: Props) => {
  const {
    alt, callback, level, imgkey, identityId, ...imgProps
  } = props;
  const [src, setSrc] = useState('');

  useEffect(() => {
    let ignore = false;

    const getImage = async () => {
      const response = await StorageService.getImage(
        imgkey,
        level || S3Level.PUBLIC,
        identityId,
      );

      if (typeof response === 'string' && !ignore) {
        setSrc(response);
        if (callback) {
          callback();
        }
      }
    };

    getImage();

    return () => {
      ignore = true;
    };
  }, []);

  return src ? <img alt={alt} src={src} {...imgProps} /> : null;
};

export default S3Image;
